// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".author-list{font-size:13px;line-height:24px;color:#7d8290}.author-list._mobile{font-size:16px;line-height:24px}.author-list__item{transition:color .3s;text-decoration:none;color:#7d8290}.author-list__item:hover:not(span){color:#3d70b2}@media screen and (max-width:900px){.author-list__item:hover{color:#7d8290}.author-list__item._tap{color:#3d70b2}}", ""]);
// Exports
module.exports = exports;
